import React, { useState } from "react";
import css from "./Login.module.css";
import cn from "classnames";
import { Link } from "react-router-dom";
function Login({ submitLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  function handleEmail(event) {
    setEmail(event.target.value);
  }
  function handlePassword(event) {
    setPassword(event.target.value);
  }
  function onSubmit(event) {
    event.preventDefault();
    submitLogin(email, password);
  }
  return (
    <div>
      <Link to="/RegisterUser">
        <li className={css.registerBar}> Register</li>
      </Link>
      <form className={css.loginContainer}>
        <h1> Login </h1>
        <input
          type="text"
          name="email"
          placeholder="email"
          onChange={handleEmail}
          value={email}
          className={css.inputLogin}
        ></input>
        <input
          type="password"
          name="password"
          placeholder="password"
          onChange={handlePassword}
          value={password}
          className={css.inputPassword}
        ></input>
        <button onClick={onSubmit} className={css.myButton}>
          Log in
        </button>
      </form>
    </div>
  );
}
export default Login;
